<svg width="38" height="30" viewBox="0 0 38 30" fill="none" xmlns="http://www.w3.org/2000/svg">
<g clip-path="url(#clip0_2229_6269)">
<rect x="2.2" y="7.2" width="33.6" height="15.6" rx="2.3" stroke="currentColor" stroke-width="1.4"/>
<path d="M8.50005 11.5C8.87192 11.5 9.20005 11.7051 9.20005 11.9375V18.0625C9.20005 18.3086 8.87192 18.5 8.50005 18.5C8.1063 18.5 7.80005 18.3086 7.80005 18.0625V11.9375C7.80005 11.7051 8.1063 11.5 8.50005 11.5Z" fill="currentColor"/>
</g>
<defs>
<clipPath id="clip0_2229_6269">
<rect width="38" height="30" rx="3" fill="white"/>
</clipPath>
</defs>
</svg>
